import Axios from "axios"
import { join } from "lodash"
import { config } from "../config/constants"

export const getUserSettings = async () => {
    return await Axios({
        method: "GET",
        url: join([config.API_URL, "/user/user_settings"], "")
    })
}